(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    var form = event.target.closest('#CollectionFilters');
    if (!form) return;
    var range = event.target.closest('[data-price-range]');
    if (range) {
      var label = form.querySelector('[data-price-value]');
      if (label) label.textContent = range.value;
    }
    form.submit();
  });

  document.addEventListener('input', function (event) {
    var range = event.target.closest('[data-price-range]');
    if (!range) return;
    var form = range.closest('#CollectionFilters');
    var label = form && form.querySelector('[data-price-value]');
    if (label) label.textContent = range.value;
  });

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-sort-option]');
    if (!chip) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', chip.getAttribute('data-sort-option'));
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();
})();
